module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relation"
  }, [(_vm.$route.query.logo && _vm.$route.query.logo !== 'null') ? _c('div', {
    staticClass: "relation-logo"
  }, [_c('img', {
    staticStyle: {
      "width": "14rem",
      "height": "5rem"
    },
    attrs: {
      "src": _vm.$route.query.logo,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "relation-name"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "relation-name-main"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.name))]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "relation-code"
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.$route.query.code) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "relation-text"
  }, [_vm._v("\n    复制邀请码，下载投资者APP注册时输入\n  ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": require("../../common/images/inviteTitle.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticStyle: {
      "width": "38px"
    },
    attrs: {
      "src": require("../../common/images/wave.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": "0.3",
      "padding": "0 10px 0 30px"
    }
  }, [_c('p', {
    staticStyle: {
      "border": "1px solid",
      "width": "30%",
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": "0.3",
      "padding": "0 30px 0 10px"
    }
  }, [_c('p', {
    staticStyle: {
      "border": "1px solid",
      "width": "30%",
      "float": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "64px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "58px"
    },
    attrs: {
      "src": require("../../common/images/cloud.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": require("../../common/images/half-round.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../common/images/relation.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../common/images/download.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relation-foot"
  }, [_c('div', {
    staticClass: "foot-btn"
  }, [_c('div', {
    staticClass: "foot-text"
  }, [_vm._v("\n        为了顺利完成线上签约，请识别二维码下载APP\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad44c13e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relation/index.vue
// module id = 1082
// module chunks = 1